import { Box, BoxProps, ButtonNew, ModalDialog, ModBox, Spacer, Text } from '@jfs/ui-new'
import { getErrorMessage, getRandomAlphaNumString } from '@jfs/utils'
import { useIsFocused } from '@react-navigation/native'
import * as React from 'react'
import { FC, ReactElement, useCallback, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { Dimensions } from 'react-native'
import { GestureHandlerGestureEvent } from 'react-native-gesture-handler'
import { CalendarTypes } from '../../comps/Calendar/types'
import CalendarViewModal from '../../comps/CalendarViewModal'
import EmptyView from '../../comps/EmptyView'
import Tabbar, { TabbarType, TabData } from '../../comps/Tabbar'
import {
  TitleSubtitleLayout,
  TitleSubtitleLayoutColorTheme,
  TitleSubtitleLayoutTypes,
} from '../../comps/TitleSubtitleLayoutNew'
import { refundHighlightLabelArray } from '../../data/static/data'
import { actionMenuStrings, transactionScreenStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { calendarWebWidth, getRangeDate, getYesterday, useWindowDimensions } from '../../util/util'
import { FileUpload } from './FileUpload'
import { InitRefund } from './InitRefund'
export interface HighlightsProps {
  title?: string
  canViewHighlightsData: boolean
  updateTabIndex?: any
  onDoneUpload?: any
}

const stats = [
  { title: 'Today' },
  { title: 'Yesterday' },
  { title: 'This Week' },
  { title: 'This Month' },
  { title: 'Custom Dates', iconId: 'CALENDAR' },
]

const renderItem = ({ item }: { item: any }): JSX.Element => {
  return (
    <TitleSubtitleLayout
      type={TitleSubtitleLayoutTypes.BOLD_TITLE_TRENDS}
      placeHolder={item.title}
      color={TitleSubtitleLayoutColorTheme.BOLD_TITLE_TRENDS}
      title={item.subtitle}
      tooltip={item?.tooltip ?? ''}
      hideIcon={false}
      key={getRandomAlphaNumString(3)}
    />
  )
}

const Highlights: FC<HighlightsProps> = ({ canViewHighlightsData = true, updateTabIndex, onDoneUpload }) => {
  const [initRefundVisible, setInitRefundVisible] = useState(false)
  const [bulkRefundVisible, setBulkRefundVisible] = useState(false)
  const {
    date,
    setSearchString,
    setNewDate,
    getRefundStats,
    mid,
    fetchStats,
    setMessage,
    dateLabel,
    setSearchFilterItem,
    setSearchResultVisibility,
    fileUploadProgress,
    setUploadStatus,
    setSize,
    setCount,
    setFileUploadProgress,
    downloadSampleBulkRefundFile,
    canIssueRefund,
    canIssueBulkRefund,
    dateTabIndex,
    setDateTabIndex,
  } = useStores((store) => ({
    dateTabIndex: store?.settings?.metaData.dateTabIndex,
    setDateTabIndex: store?.settings?.metaData.setDateTabIndex,
    getRefundStats: store?.settings?.metaData?.getRefundStats,
    fetchStats: store?.settings?.metaData?.fetchStatsV3,
    mid: store?.user?.selectedMid,
    totalRefundAmount: store?.settings?.metaData?.totalRefundAmount,
    date: store?.settings?.metaData?.selectedDate,
    setNewDate: store?.settings?.metaData?.updateDates,
    dateLabel: store?.settings?.metaData?.selectedDate?.dateLabel,
    setMessage: store?.response?.setMessage,
    setSearchFilterItem: store.settings.metaData.setSearchFilterItem,
    setSearchString: store.settings.metaData.setSearchString,
    setSearchResultVisibility: store.settings.metaData.setSearchResultVisibility,
    fileUploadProgress: store.settings.metaData.fileUploadProgress,
    setUploadStatus: store?.bulkRefund?.setUploadStatus,
    setSize: store?.bulkRefund?.setSize,
    setCount: store?.bulkRefund?.setCount,
    setFileUploadProgress: store.settings.metaData.setFileUploadProgress,
    downloadSampleBulkRefundFile: store.bulkRefund.downloadSampleBulkRefundFile,
    canIssueBulkRefund: store.userManagement.isBulkRefundAvailable(),
    canIssueRefund: store.userManagement.canIssueRefund(),
  }))
  const [fetchRefundStatsApi, apiHandler] = useLazyApiData(fetchStats)
  const { state } = apiHandler
  const isFocused = useIsFocused()
  const getYesterdayValue = useCallback(() => {
    const yesterdayBegin = getYesterday('START')
    const yesterdayEnd = getYesterday('END')
    setNewDate({
      fromDate: yesterdayBegin,
      toDate: yesterdayEnd,
      dateLabel: actionMenuStrings.yesterday,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSelectedDate = useCallback(
    (type: number): Date => {
      const getSelectedValue: any = {
        0: getTodayValue(),
        1: getYesterdayValue(),
        2: getDateValue(7),
        3: getDateValue(30),
      }
      return getSelectedValue[type]
    },
    [getYesterdayValue],
  )

  useEffect(() => {
    if (mid && isFocused) {
      //fetch summery stats
      fetchRefundStatsApi(mid, 'refunds', undefined, false, dateLabel === 'custom')
      if (dateLabel === 'custom') {
        updateCustomDateString(date.fromDate, date.toDate)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchRefundStatsApi, mid, isFocused, dateTabIndex, setNewDate, dateLabel, date.fromDate, date.toDate])

  // useEffect(() => {
  //   if (mid && state === 'fulfilled' && totalRefundAmount.length === 0) {
  //     fetchRefundStatsApi(mid, 'refunds', true, value === 0)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [state])

  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles(viewPortWidth)

  const [visible, setVisible] = useState(false)
  const [tabbarData, setTabbarData] = useState<TabData[]>(stats)
  const [layoutPos, setLayoutPos] = useState<any>('')
  const [calendarLayout, setCalendarLayout] = useState<any>('')
  const windowWidth = Dimensions.get('window').width
  const calendarLayoutWdith = calendarLayout?.layout?.width
  const remainingWidth = windowWidth - calendarLayoutWdith
  const isWebCalendarOpenInNative = windowWidth - calendarWebWidth < 200
  const [calenderPos, setCalenderPos] = useState<any>({ left: undefined, top: undefined, right: undefined })

  const onDateSelected = (firstdate: Date, secondDate?: Date): void => {
    if (secondDate) {
      updateCustomDateString(firstdate, secondDate)
      setVisible(false)
      setNewDate({
        fromDate: firstdate,
        toDate: secondDate,
        dateLabel: 'custom',
      })
      setDateTabIndex(dateTabIndex < 4 ? 4 : dateTabIndex + 1)
    }
  }

  const updateCustomDateString = useCallback(
    (fromDate: any, toDate: any) => {
      if (dateLabel === 'custom') {
        const dateString = getRangeDate(fromDate, toDate)
        const updatedStatistics = stats.slice()
        const items: TabData[] = []
        updatedStatistics.map((item) => {
          if (item.title === 'Custom Dates') {
            items.push({ title: dateString, iconId: item.iconId })
          } else {
            items.push(item)
          }
          return item
        })
        setTabbarData(items)
      }
    },
    [dateLabel],
  )

  const getListData = () => {
    const statsData = getRefundStats()
    const retData = statsData.map((item: string, index: number) => ({
      title: item,
      subtitle: refundHighlightLabelArray[index].caption,
      tooltip: refundHighlightLabelArray[index].tooltip,
    }))

    return retData
  }
  const ListData = getListData()
  const getDateValue = (dateValue: number): Date => {
    const today = new Date(Date.now())
    return new Date(today.setDate(today.getDate() - dateValue))
  }

  const getTodayValue = (): Date => {
    const today = new Date(Date.now())
    return new Date(today.setHours(0, 0, 0, 0))
  }

  const handleSelected = (index: number): void => {
    if (index === 1) {
      setDateTabIndex(index)
      getSelectedDate(index)
    } else if (index < 4) {
      setDateTabIndex(index)
      const today = new Date(Date.now())
      const currentDay = today
      const finishDay = getSelectedDate(index)
      setNewDate({
        fromDate: finishDay,
        toDate: currentDay,
        dateLabel: 'specific',
      })
    } else {
      setTimeout(() => {
        setVisible(true)
      }, 300)
    }
  }
  const close = (): void => {
    setVisible(false)
  }

  const selectedHandler = (index: number): void => {
    handleSelected(index)
  }

  const getListView = (): ReactElement[] => {
    return ListData.map((item: any) => {
      return renderItem({ item })
    })
  }

  const onCalendarLayout = (nativeEventData: GestureHandlerGestureEvent) => {
    if (calendarLayout === '') {
      setCalendarLayout(nativeEventData?.nativeEvent)
      layoutPos.target?.measure((...args: any) => {
        const left = !isWebCalendarOpenInNative ? args[4] - 170 - args[0] : undefined

        const top = args[5] - args[1] + 15
        const right = remainingWidth < calendarLayoutWdith || isWebCalendarOpenInNative ? 17 : undefined
        setCalenderPos({
          left,
          top,
          right,
        })
      })
    }
  }

  /*   const returnLeftValue = () => {
    if (remainingWidth < calendarLayoutWdith) {
      return undefined
    } else if (!isWebCalendarOpenInNative) {
      return layoutPos?.x - layoutPos?.offsetX - 30
    } else {
      return undefined
    }
  }

  const returnTopValue = () => {
    return layoutPos?.y - layoutPos?.offsetY + 15
  }

  const returnRightValue = () => {
    if (remainingWidth < calendarLayoutWdith || isWebCalendarOpenInNative) {
      return 17
    } else {
      return undefined
    }
  } */

  const renderCalendarModal = (): ReactElement => {
    return (
      <ModBox {...styles(viewPortWidth).modal} show={visible}>
        <Box onPress={close} testID="close" underlayColor={'TRANSPARENT'} {...styles(viewPortWidth).overlayStyle}>
          <Box
            onLayout={onCalendarLayout}
            {...styles(viewPortWidth).dropdownStyle(calenderPos.left, calenderPos.top, calenderPos.right)}
            backgroundColor="AVAILABLE_GREEN">
            <CalendarViewModal
              onDateSelection={onDateSelected}
              dateRange={getRangeDate(date.fromDate, date.toDate)}
              type={CalendarTypes.HISTORY}
              onCancel={close}
              maxDuration={31}
              sendError={(err: string) => setMessage(err)}
            />
          </Box>
        </Box>
      </ModBox>
    )
  }

  const renderPortal = (): React.ReactPortal => {
    return ReactDOM.createPortal(renderCalendarModal(), document.body)
  }

  const onDismiss = (shouldNavigate?: boolean) => {
    setInitRefundVisible(false)
    setSearchString('')
    setSearchFilterItem('Merchant Ref No.')
    setSearchResultVisibility(false)
    if (shouldNavigate) {
      updateTabIndex(0)
      // pull latest data from server
      fetchRefundStatsApi(mid, 'refunds', undefined, false, dateLabel === 'custom')
    }
  }
  const renderInitRefund = (): ReactElement => {
    return <InitRefund onDismiss={onDismiss} />
  }
  const renderInitRefundModal = (): React.ReactPortal => {
    return ReactDOM.createPortal(renderInitRefund(), document.body)
  }

  const onLayout = (nativeEventData: any) => {
    setLayoutPos(nativeEventData?.nativeEvent)
    if (!calenderPos.top) {
      nativeEventData?.nativeEvent?.target?.measure((...args: any) => {
        const top = args[5] - args[1] + 15
        const left = args[4] - 170 - args[0]
        setCalenderPos({
          ...calenderPos,
          left,
          top,
        })
      })
    }
  }

  const [fileName, setFileName] = useState('')
  const [file, setFile] = useState(null)
  const resetState = (shouldNavigate?: boolean) => {
    setBulkRefundVisible(false)
    setUploadStatus('NOT_SELECTED')
    setFileName('')
    setFile(null)
    setSize(null)
    setFileUploadProgress(0)
    setCount(null)
    onDoneUpload && onDoneUpload()
    if (shouldNavigate) {
      updateTabIndex(1)
    }
  }

  const onFileSelected = (name: string, size: number, selectedFile: any) => {
    setFileName(name)
    setSize(size)
    setFile(selectedFile)
    setUploadStatus('IN_PROGRESS')
  }

  const renderBulkRefund = () => {
    if (!bulkRefundVisible) {
      return <></>
    }
    return (
      <FileUpload
        progress={fileUploadProgress}
        navToHistory={() => resetState(true)}
        name={fileName}
        onHandleCancelChangeFile={resetState}
        mid={mid}
        tabIndex={0}
        onFileSelected={onFileSelected}
        handleDownloadSampFile={downloadSampleBulkRefundFile}
        file={file}
        resetState={resetState}
      />
    )
  }
  const errorState = getErrorMessage([apiHandler])
  const handleRetry = () => {
    if (mid && isFocused) {
      fetchRefundStatsApi(mid, 'refunds', undefined, false, dateLabel === 'custom')
    }
  }

  return (
    <Box {...themedStyle.container} marginHorizontal={18}>
      {renderPortal()}
      <ModalDialog
        children={renderBulkRefund()}
        show={bulkRefundVisible}
        type={'CenteredWrap'}
        onDismiss={() => setBulkRefundVisible(false)}
      />
      {initRefundVisible && renderInitRefundModal()}
      <ModBox flexDirection={'row'} flexWrap={'wrap'}>
        <Box flex={canIssueRefund || canIssueBulkRefund ? 0.8 : 1}>
          <Box {...themedStyle.titleContainer}>
            <Text testID="homePageTitle" type={'h0Bold'}>
              {'Refunds'}
            </Text>
            <Spacer direction={'vertical'} size={8} />
            <Box {...themedStyle.exportRow}>
              <Tabbar
                default={dateTabIndex > 4 ? 4 : dateTabIndex}
                titles={tabbarData}
                onSelected={selectedHandler}
                type={TabbarType.highlights}
                onLayoutOnlyForPosition={3}
                onLayout={onLayout}
              />
              <Spacer direction={'horizontal'} size={16} />
            </Box>
          </Box>
          <Spacer hide={!canViewHighlightsData} size={24} direction={'vertical'} />
          <ModBox show={canViewHighlightsData} {...themedStyle.flexRow}>
            <ModBox show={state !== 'fulfilled'} h={80} width="100%">
              <EmptyView
                onRetry={handleRetry}
                isLoading={state === 'pending'}
                error={errorState}
                emptyMessage={transactionScreenStrings.empty}
                loadingMessage={transactionScreenStrings.loading}
                hide={state === 'fulfilled'}
              />
            </ModBox>
            {state === 'fulfilled' && getListView()}
          </ModBox>
        </Box>
        <ModBox show={canIssueRefund || canIssueBulkRefund} w={'ONE'} bg={'GREY_SEPARATOR'} />
        <ModBox
          show={canIssueRefund || canIssueBulkRefund}
          align={'center'}
          justify={'center'}
          f={0.2}
          pl={16}
          minWidth={140}>
          <ButtonNew
            onPress={() => [setInitRefundVisible(true), setSearchFilterItem('Merchant Ref No.')]}
            title={'Initiate Refund'}
            hoverColor={'PRIMARY'}
            underlayColor={'PRIMARY'}
            borderRadius={4}
            isLoading={false}
            height={36}
            hide={!canIssueRefund}
            width={180}
          />
          {canIssueBulkRefund && <Spacer direction={'vertical'} size={16} />}
          <ButtonNew
            onPress={() => setBulkRefundVisible(true)}
            title="Initiate Bulk Refund"
            borderWidth={1}
            borderColor={'BLUE'}
            borderRadius={4}
            hoverColor={'TRANSPARENT'}
            underlayColor={'TRANSPARENT'}
            height={36}
            color={'WHITE'}
            titleColor={'BLUE'}
            width={180}
            hide={!canIssueBulkRefund}
            shadowType={'shadowSecondary'}
          />
        </ModBox>
      </ModBox>
    </Box>
  )
}

const styles = (breakpoint: number) => {
  let overRideFlex: BoxProps = {}
  let overRideTab: BoxProps = {}
  let overRideFlexRow: BoxProps = {}
  let overrideExportRow: BoxProps = {}
  let overrideTitleContainer: BoxProps = {}

  const shadowStyle = {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: '#0000001F',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#00000014',
    zIndex: 10,
  }

  if (breakpoint < 1032) {
    overrideExportRow = {
      flexDirection: 'column',
      justifyContent: 'space-between',
      flexGrow: 1,
    } as BoxProps
    overrideTitleContainer = {
      flexDirection: 'column',
      align: 'flex-start',
    } as BoxProps
  }
  if (breakpoint < 1000) {
    overRideFlex = {
      flexDirection: 'column',
      alignItems: 'flex-start',
    } as BoxProps
    overRideTab = {
      marginTop: 15,
    } as BoxProps
  }

  if (breakpoint < 600 && breakpoint > 460) {
    overRideFlexRow = {
      justifyContent: 'flex-start',
    } as BoxProps
  }

  if (breakpoint < 380) {
    overRideTab = {
      marginTop: 15,
      width: 300,
    } as BoxProps
  }
  return {
    container: {
      ...shadowStyle,
      padding: 16,
      minHeight: 5,
      backgroundColor: 'WHITE',
      paddingBottom: 10,
      ph: 16,
    } as BoxProps,
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'WHITE',
      justifyContent: 'space-between',
      marginTop: 16,
      ...overRideFlex,
    } as BoxProps,
    textContainer: {
      flexDirection: 'row',
      backgroundColor: 'WHITE',
    } as BoxProps,
    tabbar: {
      justifyContent: 'flex-start',
      backgroundColor: 'WHITE',
      ...overRideTab,
    } as BoxProps,
    titleContainer: {
      flexDirection: 'row',
      align: 'center',
      justify: 'space-between',
      flexWrap: 'wrap',
      ...overrideTitleContainer,
    } as BoxProps,
    exportRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      ...overrideExportRow,
    } as BoxProps,
    listStyle: { flex: 1, justifyContent: 'space-between' } as BoxProps,
    flexRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      ...overRideFlexRow,
    } as BoxProps,
    modal: {
      position: 'absolute',
      elevation: 2,
      shadowOpacity: 1,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      ...shadowStyle,
      zIndex: 1,
      borderWidth: 1,
      borderColor: 'GRAY_BORDER',
    } as BoxProps,
    overlayStyle: {
      backgroundColor: 'TRANSPARENT',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
    } as BoxProps,
    dropdownStyle: (XAxisPos: number | undefined, yAxisPos: number | undefined, rightPos: number | undefined) =>
      ({
        position: 'absolute',
        flex: 1,
        shadowColor: 'BLACK_LIGHT',
        shadowOffset: {
          width: 0,
          height: 2,
        },
        shadowOpacity: 0.3,
        shadowRadius: 10,
        elevation: 2,
        left: XAxisPos,
        top: yAxisPos ? yAxisPos + 15 : undefined,
        borderRadius: 12,
        backgroundColor: 'BLUE',
        borderColor: 'SECONDARY_GREY',
        alignSelf: 'center',
        right: rightPos,
      } as BoxProps),
  }
}

export default Highlights
